// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__hbVon","modalBody":"ConfirmationPop_modalBody__XuArU"};